import React from "react";
import { DateTime } from "luxon";
import { PositionedOverlayComponent } from "./Mixins";
export class MonthSelectionPaneComponent extends PositionedOverlayComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedDt: this.props.selectedDt,
            startDt: this.props.selectedDt.startOf("year"),
            origin: this.props.selectedDt.startOf("year"),
            validDates: undefined,
        };
    }
    static getDerivedStateFromProps(props, state) {
        return {
            selectedDt: props.selectedDt,
            startDt: state.selectedDt.toMillis() === props.selectedDt.toMillis() ? state.startDt : props.selectedDt.startOf("year"),
            origin: state.origin
        };
    }
    componentDidMount() {
        this.createOverlay();
    }
    componentWillUnmount() {
        this.disposeOverlay();
    }
    navigate(increment) {
        this.setState({ startDt: this.state.startDt.plus({ years: increment }) });
    }
    isBeyondMax(dt) {
        return !!this.props.maxDt && dt.startOf("month") > this.props.maxDt.startOf("month");
    }
    select(month) {
        if (this.isBeyondMax(month.dt))
            return;
        this.hideOverlay();
        this.setState({ selectedDt: month.dt, origin: month.dt });
        !!this.props.onSelected && this.props.onSelected(month.dt);
    }
    toOrigin() {
        this.setState({ startDt: this.state.origin.startOf("year") });
    }
    toToday() {
        this.setState({ startDt: DateTime.now().startOf("year") });
    }
    constructRows() {
        let dt = this.state.startDt;
        let endDt = dt.plus({ years: 1 }).startOf("year");
        let rows = [];
        while (dt.toMillis() < endDt.toMillis()) {
            let col = (dt.month % 4) - 1;
            let row = rows.find(x => x.col === col);
            if (!row) {
                row = { col: col, months: [] };
                rows.push(row);
            }
            row.months.push({
                dt: dt.startOf("month"),
                month: dt.toFormat("MMM"),
                ordinal: dt.toMillis(),
                isToday: dt.month === DateTime.now().month && dt.year === DateTime.now().year,
                isSelectedMonth: dt.month === this.state.selectedDt.month && dt.year === this.state.selectedDt.year,
                isBeyondMax: this.isBeyondMax(dt)
            });
            dt = dt.plus({ months: 1 });
        }
        return rows;
    }
    render() {
        this.props.shown && this.showOverlay();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.positionPane.bind(this), className: "ds-pane", role: "dialog", "aria-label": "V\u00E6lg m\u00E5ned", tabIndex: -1, style: { display: this.props.shown ? "flex" : "none" } },
                React.createElement("div", { className: "ds-pane-navigation" },
                    React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "Forrige \u00E5r", onClick: () => this.navigate(-1) },
                        React.createElement("i", { className: "fa-regular fa-less-than no-text", "aria-hidden": "true" })),
                    React.createElement("span", null, `${this.state.startDt.toFormat("yyyy")}`),
                    React.createElement("span", null,
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "I dag", onClick: () => this.toToday() },
                            React.createElement("i", { className: "fa-regular fa-calendar no-text", "aria-hidden": "true" })),
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "Det valgte", onClick: () => this.toOrigin() },
                            React.createElement("i", { className: "fa-regular fa-circle-dot no-text", "aria-hidden": "true" })),
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "N\u00E6ste \u00E5r", onClick: () => this.navigate(1), disabled: this.isBeyondMax(this.state.startDt.plus({ years: 1 }).startOf("year")) },
                            React.createElement("i", { className: "fa-regular fa-greater-than no-text", "aria-hidden": "true" })))),
                React.createElement("div", { className: "ds-pane-dates" }, this.constructRows().map((row, i) => {
                    return (React.createElement("div", { key: `year-${i}`, className: "ds-pane-dates-col" }, row.months.map((month, j) => {
                        const selectedMonth = month.isSelectedMonth ? " selected-date" : "";
                        const currentMonth = month.isToday ? " current-date" : "";
                        const beyondMax = month.isBeyondMax ? " invalid-date" : "";
                        return (React.createElement("button", { type: "button", key: `y-${i}-${j}`, className: `ds-pane-datecol-date${selectedMonth}${currentMonth}${beyondMax}`, disabled: month.isBeyondMax, "aria-label": month.dt.toFormat("MMMM yyyy"), "aria-pressed": month.isSelectedMonth, "aria-current": month.isToday ? "date" : undefined, onClick: () => this.select(month) },
                            React.createElement("span", { "aria-hidden": "true" }, month.month)));
                    })));
                })))));
    }
}
